"use strict";

exports.wrapPageElement = require('./wrap-page');